import { Colors } from './color.constants';

export const COverviewActionStyleAndIcons = {
  error: {
    statusStyle: `color: var(--content-negative, ${Colors.cards.error})`,
    cardStyle: `border-top: 3px solid var(--content-negative, ${Colors.cards.error}); border: 3px solid var(--content-negative, ${Colors.cards.error})`,
    canStatus: 'Error',
    status: 'Error',
    dialogStyle: `background:var(--content-negative, ${Colors.cards.error});`,
    color: `var(--content-negative, ${Colors.cards.error})`,
  },
  full: {
    statusStyle: `color: var(--content-negative, ${Colors.cards.full})`,
    cardStyle: `border-top: 3px solid var(--content-negative, ${Colors.cards.full}); border: 3px solid var(--content-negative, ${Colors.cards.full})`,
    canStatus: 'Full',
    status: 'Full Capacity',
    dialogStyle: `background:var(--content-negative, ${Colors.cards.full});`,
    color: `var(--content-negative, ${Colors.cards.full})`,
  },
  lockboxfull: {
    statusStyle: `color: var(--content-warning, ${Colors.cards.lockboxfull})`,
    cardStyle: `border-top: 3px solid var(--content-warning, ${Colors.cards.lockboxfull}); border: 3px solid var(--content-warning, ${Colors.cards.lockboxfull})`,
    canStatus: 'Lockbox Full',
    status: 'RX Intercep Samples',
    dialogStyle: `background: var(--content-warning, ${Colors.cards.lockboxfull});`,
    color: `var(--content-warning, ${Colors.cards.lockboxfull})`,
  },
  readyForReview: {
    statusStyle: `color: var(--content-accent,${Colors.cards.readyForReview})`,
    cardStyle: `border-top: 3px solid var(--content-accent,${Colors.cards.readyForReview}); border: 3px solid var(--content-accent, ${Colors.cards.readyForReview});`,
    canStatus: 'Ready for Review',
    status: 'AnytimeWitness Ready',
    dialogStyle: `background: var(--content-accent,${Colors.cards.readyForReview});`,
    color: `var(--content-accent,${Colors.cards.readyForReview})`,
  },
};

export const COverviewActionStatusBar = [
  {
    icon: 'full',
    label: 'Error:',
    description: 'Require Immediate Attention',
    style: `color: ${Colors.cards.error}`,
  },
  {
    icon: 'action-full',
    label: 'Notify building service :',
    description: 'Waste Full',
    style: `color: #${Colors.cards.full}}`,
  },
  {
    icon: 'lockbox-full',
    label: 'Lockbox Full:',
    description: 'RX Intercep Samples',
    style: `color: ${Colors.cards.lockboxfull}`,
  },
  {
    icon: 'ready-for-review',
    label: 'Ready for Review:',
    description: 'AnytimeWitness Ready',
    style: `color: ${Colors.cards.readyForReview}`,
  },
];

export const COverviewStatus = {
  FULL: 'Full',
  RX_INTERCEPT_SAMPLES: 'RX Intercep Samples',
  ANYTIME_WITNESS_READY: 'AnytimeWitness Ready',
  ERROR: 'Error',
};
